import { Tab } from 'bootstrap';

function initWinesTabs() {
    const select = document.querySelector('#wines-tabs-select');

    if (!select) {
        return;
    }

    const tabButtons = Array.from(document.querySelectorAll('#wines-tabs [data-bs-toggle="tab"]'));

    if (!tabButtons.length) {
        return;
    }

    const showTabForTarget = (targetSelector) => {
        const tabButton = tabButtons.find((button) => button.dataset.bsTarget === targetSelector);

        if (!tabButton) {
            return;
        }

        Tab.getOrCreateInstance(tabButton).show();
    };

    select.addEventListener('change', (event) => {
        showTabForTarget(event.target.value);
    });

    tabButtons.forEach((button) => {
        button.addEventListener('shown.bs.tab', (event) => {
            const targetSelector = event.target.dataset.bsTarget;

            if (targetSelector) {
                select.value = targetSelector;
            }
        });
    });
}

export default initWinesTabs;